import React, { useState, useEffect } from "react";
import "./Onboard.css";
import axios from "axios";
import Constant from "../../utils/constant";
import { validateOnboardingForm } from "../../utils/Validation.js";

import PersonalInfoSection from "./Sections/PersonalInfo";
import EmploymentDetailsSection from "./Sections/EmploymentDetailsSection.js";
import EducationSection from "./Sections/EducationInfo";
import PreviousEmploymentSection from "./Sections/PreviousEmploymentSection";
import DocumentVerificationSection from "./Sections/DocuemntInfo.js";
import useOnboardingForm from "../../hooks/useOnboardingForm";
import CredentialsModal from "./Sections/LoginCredModal.js";
export default function OnboardingForm() {
  const {
    employeeData,
    setEmployeeData,
    companyData,
    setCompanyData,
    familyDetail,
    setFamilyDetail,
    class10Details,
    setClass10Details,
    class12Details,
    setClass12Details,
    chequePhoto,
    setChequePhoto,
    btnClicked,
    states,
    setShowCredentialsModal,
    employeeCredentials,
    showCredentialsModal,
    cities,
    pincodes,
    permanentCities,
    permanentPincodes,
    manager,
    department,
    role,
    workLocations,
    filteredWorkLocations,
    photoLoad,
    setPhotoLoad,
    errors,
    setErrors,
    handleInputChange,
    handleStateChange,
    handleCityChange,
    handlePermanentStateChange,
    handlePermanentCityChange,
    handleInputChangeCompany,
    addJobSection,
    removeCompanySection,
    AddFamilyMember,
    deleteFamily,
    deleteFile,
    handleWorkLocationChange,
    handleWorkLocationSelect,
    handleSubmit,
    generateEmployeeId,
  } = useOnboardingForm();

  return (
    <div className="OnboardingFormContainer">
      <h4 className="text-uppercase text-center">Onboard Employee</h4>
      <form onSubmit={handleSubmit}>
        <PersonalInfoSection
          employeeData={employeeData}
          handleInputChange={handleInputChange}
          states={states}
          cities={cities}
          pincodes={pincodes}
          permanentCities={permanentCities}
          permanentPincodes={permanentPincodes}
          handleStateChange={handleStateChange}
          handleCityChange={handleCityChange}
          handlePermanentStateChange={handlePermanentStateChange}
          handlePermanentCityChange={handlePermanentCityChange}
          errors={errors}
          deleteFile={deleteFile}
          photoLoad={photoLoad}
          familyDetail={familyDetail}
          deleteFamily={deleteFamily}
          AddFamilyMember={AddFamilyMember}
        />
        <EducationSection
          employeeData={employeeData}
          class10Details={class10Details}
          class12Details={class12Details}
          handleInputChange={handleInputChange}
          errors={errors}
          deleteFile={deleteFile}
          photoLoad={photoLoad}
          // ... pass other education-related props
        />
        <PreviousEmploymentSection
          companyData={companyData}
          handleInputChangeCompany={handleInputChangeCompany}
          addJobSection={addJobSection}
          removeCompanySection={removeCompanySection}
          deleteFile={deleteFile}
          photoLoad={photoLoad}
        />

        <EmploymentDetailsSection
          employeeData={employeeData}
          handleInputChange={handleInputChange}
          manager={manager}
          department={department}
          role={role}
          workLocations={workLocations}
          filteredWorkLocations={filteredWorkLocations}
          handleWorkLocationChange={handleWorkLocationChange}
          handleWorkLocationSelect={handleWorkLocationSelect}
          errors={errors}
          photoLoad={photoLoad}
          deleteFile={deleteFile}
          generateEmployeeId={generateEmployeeId}
          btnClicked={btnClicked}
        />

        <DocumentVerificationSection
          employeeData={employeeData}
          handleInputChange={handleInputChange}
          deleteFile={deleteFile}
          photoLoad={photoLoad}
          chequePhoto={chequePhoto}
        />
        {employeeCredentials && (
          <CredentialsModal
            show={showCredentialsModal}
            handleClose={() => setShowCredentialsModal(false)}
            credentials={employeeCredentials}
          />
        )}

        <button
          type="submit"
          // onClick={validateOnboardingForm}
          className="signup-btn"
        >
          Add Employee
        </button>
      </form>
    </div>
  );
}
